import { riskMetrics } from '@/utils/riskStats';
import Reveal from '@/components/base/Reveal';

const toneClass: Record<string, string> = {
  profit: 'text-profit-600',
  loss: 'text-loss-500',
  neutral: 'text-foreground-950',
};

function RiskReality() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[30px] leading-[1.1] sm:text-[40px] lg:text-[46px] max-w-[760px]">
            The System Does Not Avoid Losses. It Records Them.
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-foreground-600 max-w-[660px]">
            Trading results include both winning and losing positions. The purpose of this page is
            to show how the system moves through the trading process, not to imply that every trade
            will be profitable.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {riskMetrics.map((m, idx) => (
            <Reveal key={m.label} delay={idx * 80}>
              <div className="rounded-lg border border-background-200 bg-background-100 px-5 md:px-6 py-5 h-full hover:-translate-y-0.5 transition-transform duration-300">
                <p className="text-[12px] text-foreground-500">{m.label}</p>
                <p
                  className={`mt-3 font-data text-[26px] md:text-[30px] font-semibold leading-none ${toneClass[m.tone]}`}
                >
                  {m.value}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-8 text-[12px] leading-relaxed text-foreground-400 max-w-[720px]">
            Historical trading results do not guarantee future results. Trading leveraged
            instruments involves significant risk.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default RiskReality;